export const safeJsonParse = <T>(str: string) => {
	try {
		const jsonValue: T = JSON.parse(str) as T;
		return jsonValue;
	} catch {
		return undefined;
	}
};

export const getFromLocalStorage = <T>(key: string) => {
	const strValue = localStorage.getItem(key);
	if (strValue) {
		return safeJsonParse<T>(strValue);
	}
};

export const setInLocalStorage = <T>(key: string, value: T) => {
	try {
		localStorage.setItem(key, JSON.stringify(value));
	} catch (error) {
		console.error(`Error setting localStorage key ${key}:`, error);
	}
};

export const formatDuration = (durationInSeconds: number): string => {
	const seconds = Number(durationInSeconds) || 0;
	return new Date(seconds * 1000).toISOString().slice(14, 19);
};

/**
 * Parses a lesson “link” field into a normalized http(s) URL, or returns null.
 * Accepts absolute URLs, or a host/path without a scheme (https is prepended) when the host looks plausible.
 */
export function normalizeLessonLinkUrl(raw: string): string | null {
	const s = raw.trim();
	if (!s) return null;

	const parseHttpUrl = (candidate: string, allowMinimalHost: boolean): string | null => {
		try {
			const u = new URL(candidate);
			if (u.protocol !== "http:" && u.protocol !== "https:") return null;
			if (!u.hostname) return null;
			if (allowMinimalHost) return u.href;
			const h = u.hostname.toLowerCase();
			if (
				h.includes(".") ||
				h === "localhost" ||
				/^\d{1,3}(?:\.\d{1,3}){3}$/.test(h)
			) {
				return u.href;
			}
			return null;
		} catch {
			return null;
		}
	};

	const absolute = parseHttpUrl(s, true);
	if (absolute) return absolute;

	if (/^[a-zA-Z][a-zA-Z\d+.-]*:/.test(s)) {
		return null;
	}

	return parseHttpUrl(`https://${s}`, false);
}